import { useCallback, useEffect, useState } from "react";
import { getBlockList } from "../api/block";

// 自分がブロックしているユーザー ID の一覧を取得・保持する
export const useBlockList = ({ enabled = true } = {}) => {
  const [blockedUserIds, setBlockedUserIds] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;

    const load = async () => {
      try {
        const res = await getBlockList();
        if (cancelled) return;
        if (res?.status === 200 && Array.isArray(res?.data?.blockedUsers)) {
          setBlockedUserIds(res.data.blockedUsers);
        } else {
          console.error("Failed to load block list:", res?.status);
        }
      } catch (error) {
        if (!cancelled) console.error("Failed to load block list:", error);
      } finally {
        if (!cancelled) setIsLoaded(true);
      }
    };
    load();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  const isBlocked = useCallback(
    (id) => !!id && blockedUserIds.includes(id),
    [blockedUserIds],
  );

  const markBlocked = useCallback((id) => {
    if (!id) return;
    setBlockedUserIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
  }, []);

  const markUnblocked = useCallback((id) => {
    if (!id) return;
    setBlockedUserIds((prev) => prev.filter((blockedId) => blockedId !== id));
  }, []);

  return { blockedUserIds, isLoaded, isBlocked, markBlocked, markUnblocked };
};

export default useBlockList;
